var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-rename-this{fill:#FDA23F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,10.7h-0.5C20,6.9,16.9,3.9,13,3.4V3c0-0.6-0.4-1-1-1s-1,0.4-1,1v0.4c-3.9,0.4-7,3.5-7.5,7.3H3 c-0.6,0-1,0.4-1,1s0.4,1,1,1h0.4c0.3,4.1,3.6,7.4,7.6,7.9V21c0,0.6,0.4,1,1,1s1-0.4,1-1v-0.4c4.1-0.5,7.3-3.8,7.6-7.9H21 c0.6,0,1-0.4,1-1S21.6,10.7,21,10.7z M13,18.6L13,18.6c0-0.6-0.4-1.1-1-1.1s-1,0.4-1,1v0.1c-3-0.4-5.3-2.8-5.6-5.8h0.1 c0.6,0,1-0.4,1-1s-0.4-1-1-1h0C6,8,8.2,5.9,11,5.4v0.1c0,0.6,0.4,1,1,1s1-0.4,1-1V5.4c2.8,0.4,5,2.6,5.5,5.3h0c-0.6,0-1,0.4-1,1 s0.4,1,1,1h0.1C18.3,15.7,16,18.1,13,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,8.8c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2S13.8,8.8,12,8.8z M12,13.2 c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2S12.7,13.2,12,13.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.58538bb7c47b96a8e215120a8e79e2ea.svg";
export { ForwardRef as ReactComponent };